import React from 'react';
import styled, { css } from 'styled-components';
import { useNavigate } from 'react-router-dom';

interface UserInfo {
  plan_grade: string | undefined;
  plan_start: string | undefined;
  plan_end: string | undefined;
}

interface Props {
  data: UserInfo | undefined;
  page?: string; // 선택적 page props
}

const MembershipBadge: React.FC<Props> = ({ data, page }) => {
  const navigate = useNavigate();

  const membershipLabelMap: Record<string, string> = {
    P: 'Premium',
    S: 'Standard',
    T: 'Promotion',
  };

  const label = data?.plan_grade
    ? (membershipLabelMap[data.plan_grade] ?? 'Free')
    : 'Free';

  return (
    <MemberShip>
      <BadgeStatusGroup>
        <MemberShipBadge type={data?.plan_grade}>
          <span style={{ fontFamily: 'Paperlogy', fontWeight: '700' }}>
            {label}
          </span>
        </MemberShipBadge>
        <MemberShipStatus type={data?.plan_grade}>
          {label === 'Free'
            ? '무료회원'
            : label === 'Promotion'
              ? '혜택적용'
              : '이용중'}
        </MemberShipStatus>
      </BadgeStatusGroup>
      {page === 'quickmenu' &&
        (label === 'Free' ? (
          <MemberShipLink onClick={() => navigate('/payment/plan')}>
            <span>멤버십 보기</span>
            <img
              src="/assets/images/arrow/Arrow-right-white.svg"
              alt=""
              style={{ width: '16px', height: '16px' }}
            />
          </MemberShipLink>
        ) : (
          <MemberShipDate>
            {data?.plan_start?.slice(2).replace(/-/g, '.')}~
            {data?.plan_end?.slice(2).replace(/-/g, '.')}
          </MemberShipDate>
        ))}
    </MemberShip>
  );
};

export default MembershipBadge;

const MemberShip = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const BadgeStatusGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  font-size: 14px;
`;

const MemberShipBadge = styled.div<{ type: string | null | undefined }>`
  height: 24px;
  padding: 2px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;

  ${({ type }) => {
    switch (type) {
      case 'P':
        return css`
          background:
            linear-gradient(to right, #008aff, #6900f3),
            linear-gradient(to right, #3f9bff, #7c29fb);
          background-origin: border-box;
          background-clip: padding-box, border-box;
          border: 2px solid transparent;
          border-radius: 4px;
        `;
      case 'S':
        return css`
          background:
            linear-gradient(to right, #00a2e7, #aad545),
            linear-gradient(to right, #3cb5de, #aad545);
          background-origin: border-box;
          background-clip: padding-box, border-box;
          border: 2px solid transparent;
          border-radius: 4px;
        `;
      case 'T':
        return css`
          background:
            linear-gradient(to right, #ff983b, #ff29c5),
            linear-gradient(to right, #ffb777, #ff5dd3);
          background-origin: border-box;
          background-clip: padding-box, border-box;
          border: 2px solid transparent;
          border-radius: 4px;
        `;
      case undefined:
      case null:
      default:
        return css`
          background:
            linear-gradient(to right, #c4c6cc, #85898e),
            linear-gradient(to right, #e0e1e6, #bdc1c7);
          background-origin: border-box;
          background-clip: padding-box, border-box;
          border: 2px solid transparent;
          border-radius: 4px;
        `;
    }
  }}
`;

const MemberShipStatus = styled.div<{ type: string | null | undefined }>`
  font-family: 'Paperlogy';
  font-size: 14px;
  font-weight: 700;
  color: ${({ type }) =>
    type === 'P'
      ? '#6507F4'
      : type === 'S'
        ? '#94BF08'
        : type === 'T'
          ? '#FF29C5'
          : '#898D92'};
`;

const MemberShipDate = styled.div`
  font-size: 14px;
  font-weight: 500;
  font-family: Spoqa Han Sans Neo;
  color: #222222;
`;

const MemberShipLink = styled.div`
  height: 24px;
  border-radius: 4px;
  background-color: #008aff;
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: row;
  padding: 2px 1px 2px 6px;
  cursor: pointer;
`;
